/**
 * StreamLainLogo — legacy compatibility wrapper over BrandLogo.
 *
 * Kept as a thin alias so existing imports `from '@affine/component'` don't
 * need updating. New code should import `BrandLogo` directly.
 */
import type { CSSProperties, FC } from 'react';

import { BrandLogo } from '../../brand';

export interface StreamLainLogoProps {
  className?: string;
  size?: number;
  style?: CSSProperties;
}

export const StreamLainLogo: FC<StreamLainLogoProps> = ({
  className,
  size = 24,
  style,
}) => <BrandLogo size={size} className={className} style={style} />;
